import {ChangeDetectionStrategy, Component, Input, OnDestroy} from '@angular/core'
import {faInfoCircle} from '@fortawesome/pro-solid-svg-icons/faInfoCircle'
import {faShieldCheck} from '@fortawesome/pro-solid-svg-icons/faShieldCheck'
import {faSearch} from '@fortawesome/pro-regular-svg-icons/faSearch'
import {Language} from '../../../../core/i18n/language'
import {LayoutSearchService} from '../../../../core/components/layout/layout-search/layout-search.service'
import {ApplicationRoute} from '../../../../craft/utils/application.route'
import {PUBLIC_ROUTES} from '../../../../shared/routing/public.routes'
import {Subject} from 'rxjs'
import {DialogService} from '../../../../craft/dialog/dialog.service'
import {HappinessDialogComponent} from './happinees-dialog/happiness-dialog.component'
import {TranslocoService} from '@ngneat/transloco'

@Component({
  selector: 'bgo-home-banner',
  templateUrl: './home-banner.component.html',
  styleUrls: ['./home-banner.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeBannerComponent implements OnDestroy {
  @Input() partnerText!: string
  readonly infoIcon = faInfoCircle
  readonly searchIcon = faSearch
  readonly happinessIcon = faShieldCheck
  readonly Language = Language
  readonly ArticlePage: ApplicationRoute = PUBLIC_ROUTES.ARTICLE_PAGE

  private readonly unsubscribe$ = new Subject<void>()

  constructor(
    private readonly layoutSearchService: LayoutSearchService,
    private readonly dialogService: DialogService,
    private readonly translationService: TranslocoService,
  ) {}

  ngOnDestroy(): void {
    this.unsubscribe$.next()
    this.unsubscribe$.complete()
  }

  openSearch(): void {
    this.layoutSearchService.showSearchPopup()
  }

  showHappinessDialog(): void {
    this.dialogService.show(HappinessDialogComponent, {
      text: this.translationService.translate('shared.sellingPoints.happiness.modal.text'),
    })
  }
}
